import React from 'react';
import { Tooltip } from 'antd';
import styles from './BoardHeader.module.css';
import { useCanvas } from '../../context/canvasContext';
import { useDocument } from '../../context/documentInfoContex';
import Logo from '../Logo/Logo';
import DocumentTitle from '../DocumentTitle/DocumentTitle';
import CompleteDocument from '../CompleteDoc/completeDoc';
import SavingStatus from '../SavingStatus/SavingStatus';
import BoardTools from './BoardTools/BoardTools';
import DocumentMembers from '../Members/members';
import { ShareModal } from '../ShareModal/ShareModal';
import TemplateActiveToggle from '../TemplateActiveToggle';
import TemplateThumbnail from '../TemplateThumbnail';
import AppLauncherModal from '../AppLauncher/AppLauncherModal';
import Modes from '../modes';
import HeaderAvatar from '../Avatar/HeaderAvatar';
import HeaderMenu from './HeaderMenu/HeaderMenu';
import privateIcon from '../../assets/lock.svg';
import publicIcon from '../../assets/world.svg';

/**
 * One 56px bar: logo, title over the save status, the board tools, then the
 * actions on the right. Below 768px the tools hide and the actions collapse
 * into a hamburger.
 */
const BoardHeader = () => {
    const { documentInfo, isReadOnly, isTemplateDocument } = useDocument();
    const { userInfo } = useCanvas();
    const isOwner = documentInfo?.createBy == userInfo?.userId;
    const isPrivate = documentInfo?.privacyId == 2;
    const privacyLabel = isPrivate ? 'Private board' : 'Public board';

    return (
        <header className={styles.topBar}>
            <Logo />
            <div className={styles.titleBlock}>
                <div className={styles.titleRow}>
                    <DocumentTitle />
                    {!isTemplateDocument && (
                        <Tooltip title={privacyLabel}>
                            <img
                                src={isPrivate ? privateIcon : publicIcon}
                                alt={privacyLabel}
                                className={`${styles.privacyIcon} ${isPrivate ? styles.privacyIconLock : ''}`}
                            />
                        </Tooltip>
                    )}
                    {!isReadOnly && !isTemplateDocument && <CompleteDocument />}
                </div>
                <SavingStatus />
            </div>

            <span className={styles.divider} aria-hidden="true" />
            <BoardTools />

            <div className={styles.spacer} />
            <div className={styles.actions}>
                {!isTemplateDocument && <DocumentMembers />}
                {isOwner && !isTemplateDocument && <ShareModal />}
                {isTemplateDocument && <TemplateActiveToggle />}
                {isTemplateDocument && <TemplateThumbnail />}
                <span className={styles.actionsDivider} aria-hidden="true" />
                <AppLauncherModal />
                <Modes />
                <HeaderAvatar scale={1} />
                <div className={styles.compact}>
                    <HeaderMenu />
                    <HeaderAvatar scale={1} />
                </div>
            </div>
        </header>
    );
};

export default BoardHeader;
